import { ReadyTransferOrdersPage } from "@/features/delivery-order-batch/pages/ReadyTransferOrdersPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/delivery-order-batch/$deliveryOrderBatchID/ready-transfer-orders",
)({
	component: ReadyTransferOrdersPage,
});
